import React from 'react';
import { connect } from 'react-redux';

import { PATH } from '../../../../constants/path';

import HeadComponent from '../../../HeadComponent';
import ProfileFormComponent from './ProfileFormComponent';
import LocalizedBreadcrumbItem from '../../../breadcrumb/LocalizedBreadcrumbsItem';
import InterestsFormComponent from '../myinterests/InterestsFormComponent';

import { ProfilePageContainer } from './ProfilePageStyle';

export class ProfilePage extends React.Component {
    render() {
        const { i18nPage } = this.props;
        return (
            <ProfilePageContainer>
                <HeadComponent title={i18nPage.TITLE} description={i18nPage.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.ACCOUNT_PROFILE_PATH}>
                    {i18nPage.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <ProfileFormComponent />
                <div id="p-myinterests">
                    <InterestsFormComponent />
                </div>
            </ProfilePageContainer>
        );
    }
}

export default connect(state => ({ i18nPage: state.i18n.page.ACCOUNT.PROFILE }))(ProfilePage);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/ProfilePage.js